import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Pictures from "../DetailsComponents/Pictures";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomPictures from "../DetailsComponents/BottomPictures";
import Description from "../DetailsComponents/Description";
import StrongPoint from "../DetailsComponents/StrongPoint";
import img1 from "../../../assets/Image/Details4/Photo1.jpg";
import img2 from "../../../assets/Image/Details4/Photo2.jpg";
import img3 from "../../../assets/Image/Details4/Photo3.jpg";
import img4 from "../../../assets/Image/Details4/Photo4.jpg";
import img5 from "../../../assets/Image/Details4/Photo5.jpg";
import img6 from "../../../assets/Image/Details4/Photo6.jpg";
import img7 from "../../../assets/Image/Details4/Photo7.jpg";
import img8 from "../../../assets/Image/Details4/Photo8.jpg";
import img9 from "../../../assets/Image/Details4/Photo9.jpg";
import img10 from "../../../assets/Image/Details4/Photo10.jpg";
import img11 from "../../../assets/Image/Details4/Photo11.jpg";
import {
    faArrowLeft,
    faEyeSlash,
    faHouseMedical,
    faSwimmer,
} from "@fortawesome/free-solid-svg-icons";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const images = [img1, img2, img3, img4, img5];
const images2 = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
];

const DetailsId4 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const navigate = useNavigate();

    const handleImageClick = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    };
    return (
        <div>
            <div className="px-48 xl:px-28 lg:px-24 md:px-14 sm:px-6">
                <button
                    className="w-10 h-10 mt-1 bg-customGray text-black rounded-full p-2 tansition duration-300 ease-in-out transform hover:text-customPink hover:bg-white hover:scale-125"
                    onClick={() => navigate("/acheter-louer")}
                >
                    <FontAwesomeIcon
                        className="m-auto text-base"
                        icon={faArrowLeft}
                    />
                </button>
                <Pictures
                    title="Maison avec piscine à 20min du CHU"
                    images={images}
                    onImageClick={handleImageClick}
                />
                <BottomPictures
                    place="Route de Verrières, 86410 Dienné"
                    state="Sous-offre"
                />
                <h5 className="text-2xl mt-20 mb-10">Points forts du bien</h5>
                <div className="mb-20 flex justify-around items-center reveal-left lg:flex-wrap lg:gap-8 md:flex-wrap md:gap-8 sm:flex-wrap sm:gap-8">
                    <StrongPoint icon={faSwimmer} text="Piscine" />
                    <StrongPoint icon={faHouseMedical} text="Excellente état" />
                    <StrongPoint icon={faEyeSlash} text="Pas de vis à vis" />
                </div>
                <Description
                    text="L'immobilier sur Mesure vous propose cette belle maison individuelle de plain-pied construire en 2004 (avec une extension datant de 2012) de 153m² habitable située à proximité du bourg de Dienne sur un terrain d'environ 1450m².
Calme, baignée de lumière et très bien disposée, elle se compose d'une spacieuse pièce de vie avec coin salon, salle à manger et cuisine aménagée et entièrement équipée notamment d'un îlot central ouvrant sur une magnifique terrasse de 70m².
Au niveau des pièces de nuit : Un espace avec 2 spacieuses chambres avec rangements, salle de bain et wc séparé à proximité ainsi qu'un autre espace suite à une extension se composant de 2 chambres reliées par une salle d'eau et wc privatif. Un espace modulable (bureau ou dressing par exemple) complète l'extension.
Terrain arboré avec spacieuse terrasse de 70m² sur l'arrière de la maison sans aucun vis à vis et piscine à coque de 8*4 quasiment neuve. Terrain de pétanque en construction.
Garage fermé pour garer un véhicule et stocker avec accès direct à la maison. Possibilité également de garer des véhicules sur l'avant de la maison.
Excellent état général."
                />
            </div>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                    <button
                        className="absolute top-4 right-4 text-white text-2xl"
                        onClick={() => setIsOpen(false)}
                    >
                        &times;
                    </button>
                    <div className="w-8/12 md:w-3/4 lg:w-3-4 sm:w-full">
                        <Carousel
                            selectedItem={photoIndex}
                            showThumbs={true}
                            showStatus={false}
                            swipeable={true}
                            autoPlay={true}
                            interval={4000}
                            infiniteLoop
                            useKeyboardArrows
                            onChange={(index) => setPhotoIndex(index)}
                        >
                            {images2.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={img}
                                        alt={`Show ${index + 1}`}
                                        className="object-contain w-full"
                                    />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetailsId4;
